export const AI_PREFERENCES_LOAD_REQUESTED = "AI_PREFERENCES/LOAD_REQUESTED";
export const AI_PREFERENCES_LOAD_SUCCESS = "AI_PREFERENCES/LOAD_SUCCESS";
export const AI_PREFERENCES_LOAD_FAIL = "AI_PREFERENCES/LOAD_FAIL";

export const AI_PREFERENCES_SAVE_ABOUT_YOU_REQUESTED = "AI_PREFERENCES/SAVE_ABOUT_YOU_REQUESTED";
export const AI_PREFERENCES_SAVE_ABOUT_YOU_SUCCESS = "AI_PREFERENCES/SAVE_ABOUT_YOU_SUCCESS";
export const AI_PREFERENCES_SAVE_ABOUT_YOU_FAIL = "AI_PREFERENCES/SAVE_ABOUT_YOU_FAIL";

export const AI_PREFERENCES_SAVE_ABOUT_COMPANY_REQUESTED = "AI_PREFERENCES/SAVE_ABOUT_COMPANY_REQUESTED";
export const AI_PREFERENCES_SAVE_ABOUT_COMPANY_SUCCESS = "AI_PREFERENCES/SAVE_ABOUT_COMPANY_SUCCESS";
export const AI_PREFERENCES_SAVE_ABOUT_COMPANY_FAIL = "AI_PREFERENCES/SAVE_ABOUT_COMPANY_FAIL";

export const AI_PREFERENCES_LOAD_OPTIONS = "AI_PREFERENCES/LOAD_OPTIONS";

export const appMngmtId = "v3.AI.preferences";

export default (state = {
  loading: 0,
  data: {
    aboutYou: {
      position: "",
      level: ""
    },
    aboutCompany: {
      name: "",
      website: "",
      industry: "",
      description: ""
    }
  },
  options: {
    levels: [],
    industries: [],
  },
  errors: []
}, { type, data }) => {
  switch (type) {
  case AI_PREFERENCES_LOAD_REQUESTED: {
    ++state.loading;
    return state;
  }
  case AI_PREFERENCES_LOAD_SUCCESS: {
    --state.loading;
    state.data = data;
    return state;
  }
  case AI_PREFERENCES_LOAD_FAIL: {
    --state.loading;
    // state.errors.push({ error: data, type });
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_YOU_REQUESTED: {
    ++state.loading;
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_YOU_SUCCESS: {
    --state.loading;
    state.data.aboutYou = data;
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_YOU_FAIL: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_COMPANY_REQUESTED: {
    ++state.loading;
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_COMPANY_SUCCESS: {
    --state.loading;
    state.data.aboutCompany = data;
    return state;
  }
  case AI_PREFERENCES_SAVE_ABOUT_COMPANY_FAIL: {
    --state.loading;
    state.errors.push({ error: data, type });
    return state;
  }
  case AI_PREFERENCES_LOAD_OPTIONS: {
    state.options = data || state.options;
    return state;
  }
  default:
    return state;
  }
};

export const loadRequested = data => ({ type: AI_PREFERENCES_LOAD_REQUESTED, data });
export const loadSuccess = data => ({ type: AI_PREFERENCES_LOAD_SUCCESS, data });
export const loadFail = data => ({ type: AI_PREFERENCES_LOAD_FAIL, data });

export const saveAboutYouRequested = (data, resolve, reject) => ({ type: AI_PREFERENCES_SAVE_ABOUT_YOU_REQUESTED, data, resolve, reject });
export const saveAboutYouSuccess = data => ({ type: AI_PREFERENCES_SAVE_ABOUT_YOU_SUCCESS, data });
export const saveAboutYouFail = data => ({ type: AI_PREFERENCES_SAVE_ABOUT_YOU_FAIL, data });

export const saveAboutCompanyRequested = (data, resolve, reject) => ({ type: AI_PREFERENCES_SAVE_ABOUT_COMPANY_REQUESTED, data, resolve, reject });
export const saveAboutCompanySuccess = data => ({ type: AI_PREFERENCES_SAVE_ABOUT_COMPANY_SUCCESS, data });
export const saveAboutCompanyFail = data => ({ type: AI_PREFERENCES_SAVE_ABOUT_COMPANY_FAIL, data });

export const loadOptions = data => ({ type: AI_PREFERENCES_LOAD_OPTIONS, data });
